export * from './lib/global-version.module';
